import * as Integration from '../../../data-integration/types';
import * as Types from '../../../types';
import { DataIntegrationInfo as StyledDataIntegrationInfo } from './DataIntegrationInfo.styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import * as React from 'react';
import { connect } from 'react-redux';

export interface DataIntegrationInfoProps {
  /**
   * If true, info message will fill the width of the full screen.
   */
  fullScreen?: boolean;
  /**
   * The organisation's data integration provider.
   */
  dataIntegration: Integration.Types;
  'data-testid'?: string;
}

/**
 * Info message reminding users that their organisation manages users via their data integration provider.
 */
export const DataIntegrationInfo: React.FC<DataIntegrationInfoProps> = ({
  fullScreen = false,
  dataIntegration,
  ...props
}: DataIntegrationInfoProps) => (
  <StyledDataIntegrationInfo
    fullScreen={fullScreen}
    data-testid={props['data-testid']}
  >
    <InfoOutlinedIcon />
    {`The details of users in your organisation can only be updated through ${dataIntegration}.`}
  </StyledDataIntegrationInfo>
);

// Convert authenticationType to data integration type, if equivalent exists
function authenticationTypeToDataIntegrationType(
  authenticationType: Types.AuthenticationType,
): Integration.Types | undefined {
  // Keys of Integration.Types match values of Types.AuthenticationType
  const entry = Object.entries(Integration.Types).find(
    ([key]) => key === authenticationType,
  );

  return entry ? entry[1] : undefined;
}

const mapStateToProps = ({
  integrationStatus: { dataIntegration },
  organisation: { authenticationAdmin },
}: Types.State) => ({
  dataIntegration:
    // If a scimProvider is defined, try to convert it to a data integration type
    (authenticationAdmin?.scimProvider?.provider
      ? authenticationTypeToDataIntegrationType(
          // Cast is needed because provider is defined as string
          authenticationAdmin.scimProvider.provider as Types.AuthenticationType,
        )
      : undefined) ??
    dataIntegration ??
    Integration.Types.NONE,
});

export default connect(mapStateToProps)(DataIntegrationInfo);
